export default "__VITE_ASSET__Cq2BzaHI__"